import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import TextStep from './TextStep';
import { Message } from './types';
import { styles } from './ChatMessage.styles';
import { useChatScroll } from './hooks/useChatScroll';
import MarkdownViewer from './MarkdownViewer';

const MESSAGE_TYPES = {
  USER: 'user',
  LIA: 'lia',
} as const;

interface ChatMessageProps {
  msg: Message;
  isLastLiaMessage: boolean;
  onDone?: () => void;
  onWordTyped?: () => void;
  isCompleted?: boolean;
}

const ChatMessage: React.FC<ChatMessageProps> = ({
  msg,
  isLastLiaMessage,
  onDone,
  onWordTyped,
  isCompleted = false,
}) => {
  const isUserMessage = msg.from === MESSAGE_TYPES.USER;
  const { setTyping } = useChatScroll();

  return (
    <Box
      sx={styles.messageContainer(isUserMessage)}
      data-testid="lia-chat-message"
    >
      <Avatar
        src={
          isUserMessage
            ? ''
            : `${process.env.PUBLIC_URL}/images/passarinho-lia.svg`
        }
        alt={isUserMessage ? 'Usuário' : 'Lia'}
        sx={{
          ...styles.messageAvatar,
        }}
      />
      <Box sx={styles.messageBubble(isUserMessage)}>
        {msg.from === MESSAGE_TYPES.LIA && isLastLiaMessage ? (
          <TextStep
            texto={msg.text as string}
            onDone={() => {
              setTyping(false);
              onDone?.();
            }}
            onWordTyped={() => {
              setTyping(true);
              onWordTyped?.();
            }}
            isCompleted={isCompleted}
          />
        ) : (
          <MarkdownViewer content={msg.text as string} />
        )}

        <Typography variant="caption" sx={styles.messageTime(isUserMessage)}>
          {msg.time}
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(ChatMessage);
